export default "table {\n  width: 100%;\n}\n\ntable th {\n  font-weight: 500;\n  font-size: 14px;\n  color: #66b0ff;\n}\n\n.fw-600 {\n  font-weight: 600;\n}"